'use strict';
function rbbTemplateCounter() {
  fetch(`https://tools.rbb-online.de/tools-service/api/visitors?url=${window.location.href.split('/').slice(0, 4).join('/')}`).then();
}

rbbTemplateCounter();
setInterval(rbbTemplateCounter, 300000);
